import api from '@api';
import React, { FC, useEffect, useState } from 'react';
import FileDisplay from 'src/components/FileDisplay';
import { FileType } from 'src/types/file';
import { OrderType } from 'src/types/order';

export interface ShipperLabelPropsType {
    editData: OrderType;
    idOrder: string;
    handleHideShipperLabel: () => void;
    type: 'shipResponse' | 'shipReturnResponse' | 'shipSwapResponse';
}

const ShipperLabel: FC<ShipperLabelPropsType> = (props) => {
    const [file, setFile] = useState<FileType | null>(null);

    const loadFileData = async () => {
        let url = `api/secure/orders/shipper-label/${props.idOrder}`;
        if (props.type === 'shipReturnResponse') {
            url = `api/secure/orders/shipper-return-label/${props.idOrder}`;
        } else if (props.type === 'shipSwapResponse') {
            url = `api/secure/orders/shipper-exchange-label/${props.idOrder}`;
        }
        const response: { data: { label: string } } = await api('get', url);
        if (response.data.label.indexOf(';base64,') > -1) {
            setFile({ data: response.data.label });
        } else {
            setFile({ data: `data:application/pdf;base64, ${response.data.label}` });
        }
    };

    useEffect(() => {
        if (!file) {
            loadFileData();
        }
    }, [file]);

    if (file) {
        return <FileDisplay file={file} onClose={props.handleHideShipperLabel} />;
    }
    return null;
};

export default ShipperLabel;
